import { render, staticRenderFns } from "./PokemonGame.vue?vue&type=template&id=2b475599&"
import script from "./PokemonGame.vue?vue&type=script&lang=js&"
export * from "./PokemonGame.vue?vue&type=script&lang=js&"
import style0 from "./PokemonGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports